import { createPaginatedSlice } from "../../helpers/reduxHelper";

const productConfigurators = createPaginatedSlice('productConfigurators');

export const productConfiguratorsActions = productConfigurators.actions
export const productConfiguratorsSelector = state => state.productConfigurators;
export const productConfiguratorsReducer = productConfigurators.reducer;
export default productConfiguratorsReducer

export const productConfiguratorsSelectors = productConfigurators.LF.selectors